import React, { useEffect, useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

import Tabs from '../../components/Tabs';
import Slopes from './components/Slopes';
import Lifts from './components/Lifts';

const season = drupalSettings.slopes_and_lifts_season ?? 'winter';
const selectedRoutes = drupalSettings.slopes_and_lifts_selected_routes ?? '';
const selectedLifts = drupalSettings.slopes_and_lifts_selected_lifts ?? '';

const SlopesAndLifts = () => {
  const [slopes, setSlopes] = useState();
  const [lifts, setLifts] = useState();
  const [exceptions, setExceptions] = useState();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []);

  async function fetchData() {
    const response = await fetch(
      `/${drupalSettings.current_language}/api/slopes_and_lifts?routes=${selectedRoutes}&lifts=${selectedLifts}&season=${season}`
    );
    if (response.ok) {
      const data = await response.json();
      setSlopes(data.slopes);
      setLifts(data.lifts);
      setExceptions(data.exceptions);
      setLoading(false);
    } else {
      setError(true);
      setLoading(false);
    }
  }

  return (
    <div className={`slopes-and-lifts slopes-and-lifts--season-${season}`}>
      {!isLoading ? (
        !error ? (
          <>
            {exceptions.length > 0 && (
              <div className="info-liftup">
                <h3 className="info-title">
                  {Drupal.t('Exceptions to opening hours')}
                </h3>
                {exceptions.map((exception, i) => (
                  <p key={i} className="info-text">
                    {exception}
                  </p>
                ))}
              </div>
            )}

            <Tabs
              tabs={[
                {
                  key: 'lifts',
                  name: Drupal.t('Lifts'),
                  content: <Lifts lifts={lifts} />,
                },
                {
                  key: 'slopes',
                  name:
                    season === 'winter'
                      ? Drupal.t('Slopes')
                      : Drupal.t('Routes'),
                  content: <Slopes slopes={slopes} season={season} />,
                },
              ]}
            />
          </>
        ) : (
          <h3>{Drupal.t('Error fetching data')}</h3>
        )
      ) : (
        <div className="accommodation-search__spinner">
          <BeatLoader color="#ff1706" />
        </div>
      )}
    </div>
  );
};

export default SlopesAndLifts;
